function isObjectEmpty(obj) {
    if(obj!==undefined && obj!==null){
    return Object.keys(obj).length === 0;
    }
    return obj;
}
export default isObjectEmpty;
